import { styled } from '@/shared/ui';

export const StyledWrapper = styled('div')`
  height: 100vh;
  width: 100vw;
  display: flex;

  background-color: #f3f3f3;
`;

export const StyledBox = styled('div')`
  display: flex;
  align-items: center;
  gap: 100px;
  margin: auto;
`;

export const StyledText = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 30px;

  font-weight: 400;
`;

export const StyledOops = styled('div')`
  font-size: 45px;
`;
